import React, { useState } from "react";
import styled from "styled-components";
import { Button, Alert, Modal } from "~/components-shared";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch } from "react-redux";
import mixpanel from "mixpanel-browser";
import Markdown from "~/components/Markdown";
import InputTextControl from "~/components/InputTextControl";
import signUpCompanySchema from "~/forms/SignUpCompanyForm/signUpCompanySchema";
import api from "~/lib/api";
import signUpMemberSchema from "~/forms/SignUpMemberForm/signUpMemberSchema";
import { handleError } from "~/lib/helpers";
import authActionCreators from "~/store/auth/actions";
import { object, number } from "yup";
import { useHistory } from "react-router-dom";
import { RoutesEnum } from "~/types/enums";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const StyledInputTextControl = styled(InputTextControl)`
  font-size: 2rem;
`;
const SignUpVerifyCodeModal = _ref => {
  let {
    formData,
    onClose
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    handleSubmit,
    control
  } = useForm({
    resolver: yupResolver(signUpCompanySchema.concat(signUpMemberSchema).concat(object().shape({
      code: number().required()
    }))),
    defaultValues: formData
  });
  const onSubmit = handleSubmit(data => {
    setIsLoading(true);
    api.completeSignUp(data).then(_ref2 => {
      let {
        token
      } = _ref2;
      if (token) {
        dispatch(authActionCreators.updateTokenStarted(token));
        history.replace(RoutesEnum.ONBOARDING);
      }
    }).catch(e => {
      setError(handleError(e));
    }).finally(() => {
      setIsLoading(false);
    });
    mixpanel.track(`Sign-up – Submit`, {
      ...data
    });
  });
  const handleClose = () => {
    onClose();
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("SignUpVerifyCodeModal.verifyCode"),
    onClose: handleClose,
    fullWidth: true,
    maxWidth: "420px"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(Markdown, {
    text: t("SignUpVerifyCodeModal.description", {
      email: formData.email
    }),
    fontSize: 4,
    lineHeight: 6,
    s: {
      mb: 3
    }
  }), /*#__PURE__*/React.createElement(StyledInputTextControl, {
    name: "code",
    label: t("SignUpVerifyCodeModal.verificationCode"),
    control: control,
    required: true
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleClose,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    loading: isLoading,
    s: {
      ml: 2
    },
    fullWidth: true,
    rounded: true
  }, t("SignUpVerifyCodeModal.verify")))));
};
export default SignUpVerifyCodeModal;